module.exports = __webpack_public_path__ + "static/img/logo-small.75a72a53.svg";